import {
  VEHICLE_SCHEDULE_ALL,
  VEHICLE_SCHEDULE_GET,
  VEHICLE_SCHEDULE_POST,
  VEHICLE_SCHEDULE_PUT,
  VEHICLE_SCHEDULE_DEL,
  VEHICLE_SCHEDULE_LOADING,
  VEHICLE_SCHEDULE_ERROR,
} from '../../actions/types';

const initialState = {
  vehicleSchedule: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case VEHICLE_SCHEDULE_LOADING:
      return { isLoading: true, isCompleted: true };
    case VEHICLE_SCHEDULE_ERROR:
      return { isLoading: false, isCompleted: false };
    case VEHICLE_SCHEDULE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case VEHICLE_SCHEDULE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case VEHICLE_SCHEDULE_POST:
      return { isLoading: false, isCompleted: true };
    case VEHICLE_SCHEDULE_PUT:
      return { isLoading: false, isCompleted: true };
    case VEHICLE_SCHEDULE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
